import React from 'react';
import './Dashboard.css';

function BookingReports() {
    return (
        <div className="dashboard-container">
            <header className="dashboard-header card">
                <div className="welcome-text">
                    <h1>Booking Reports</h1>
                    <p>View and analyze booking reports and statistics</p>
                </div>
            </header>

            {/* <div className="info-sections">
                <section className="info-card card">
                    <div className="info-header">
                        <h3>Booking Reports</h3>
                    </div>
                    <div className="info-content-grid">
                        <p>Booking reports interface will be implemented here.</p>
                    </div>
                </section>
            </div> */}
        </div>
    );
}

export default BookingReports;
